import { useState } from "react";

const MultiSelectFieldset = ({ data, onInputChange }) => {
  const [selectedOptions, setSelectedOptions] = useState([]);

  const { inputKey, options, required, label } = data;

  const toggleOption = (value) => {
    const updatedOptions = selectedOptions.includes(value)
      ? selectedOptions.filter((option) => option !== value)
      : [...selectedOptions, value];

    setSelectedOptions(updatedOptions);

    // Call onInputChange with updated options
    onInputChange({
      target: {
        name: inputKey,
        value: updatedOptions,
      },
    });
  };

  return (
    <fieldset className="border border-light-grey-color w-full rounded-md p-3">
      <legend className="mx-3 px-1 text-xs">
        {label} {required ? "*" : ""}
      </legend>
      <div className="flex flex-col space-y-2">
        {options.map((option) => (
          <label
            key={option.value}
            className="flex items-center space-x-2 border-b border-gray-200 pb-2"
          >
            <input
              type="checkbox"
              checked={selectedOptions.includes(option.value)}
              name={inputKey}
              onChange={() => toggleOption(option.value)}
              className="form-checkbox h-4 w-4 text-blue-600 border-gray-300 rounded"
            />
            <span className="text-sm text-gray-700">{option.label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
};

export default MultiSelectFieldset;
